import styled from "styled-components";
import { Button as DSButton, colors } from "@streeteasy/design-system";

import { Error } from "src/shared/components/Error/styled";

export const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;

  && > ${Error} {
    width: 100%;
  }
`;

export const InfoCard = styled.div`
  background-color: ${colors.ACCENT_PRIMARY_LIGHTEST};
  margin-bottom: 30px;
  padding: 18px 20px;
`;

export const Button = styled(DSButton).attrs({ size: "lg", type: "button" })`
  width: 100%;
  max-width: 287px;
  margin-bottom: 16px;
  position: relative;

  &:last-child {
    margin-bottom: 0;
  }

  &:disabled {
    &:after {
      animation: loadingButton 1.5s ease-in-out forwards;
      background-color: rgba(0, 0, 0, 0.2);
      content: "";
      display: block;
      height: 100%;
      left: 0;
      position: absolute;
      top: 0;
    }

    @keyframes loadingButton {
      0% {
        right: 100%;
      }
      100% {
        right: 8px;
      }
    }
  }
`;
